import { Box, SxProps, Theme } from '@mui/material'
import env from '../../core/config/env'

interface IAsaasSealProps {
  sx?: SxProps<Theme>
}

export function AsaasSeal({ sx }: IAsaasSealProps) {
  if (!env.SHOW_ASAAS_SEAL) return null

  return (
    <Box
      component="a"
      href="https://asaas.com"
      target="_blank"
      rel="noopener noreferrer"
      sx={{
        display: 'inline-block',
        mt: 2,
        ...sx,
      }}
    >
      <img
        src="/assets/asaas/selo-asaas.svg"
        alt="Serviços financeiros Asaas"
        style={{
          height: '40px',
          objectFit: 'contain',
        }}
      />
    </Box>
  )
}
